var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['app-page', {poker: _vm.redirect}],attrs:{"id":"app"}},[(!_vm.hideNav)?_c('navigation'):_vm._e(),_c('router-view',{staticClass:"app-content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }